/*
 *
 *  session remotes
 *
 */

import api from "../../helpers/index"

export function myAccountApi() {
  return api
    .get(`/user/user-data`)
    .then((response) => response.data && response.data.data)
    .catch((error) => Promise.reject(error))
}

export function dashboardMyApi() {
  return api.get('/Api/me').then((response) => response.data && response.data.data).catch((error) => Promise.reject(error))
}

const remotes = {
  myAccountApi,
  dashboardMyApi
}

export default remotes
